import { NavigationGuard } from 'vue-router';
import { PermissionName } from '@oare/types';
import sl from '@/serviceLocator';

const permissionGuard =
  (permission: PermissionName): NavigationGuard =>
  () => {
    const store = sl.get('store');

    if (store.hasPermission(permission)) {
      return true;
    }
    return '/403';
  };

export default permissionGuard;
